import { CircleButton } from 'component/Button/CircleButton'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { InferenceStore } from 'store/inference/InferenceStore'
import { store } from 'store/store'

type Props = {
  inference: InferenceStore
}

export const Actions = observer((_: Props) => {
  const onOpen = useLatestCallback(() => {
    store.carousel.actions = true
  })

  return (
    <CircleButton large action={onOpen}>
      <Icon size={20} name="more_vert" />
    </CircleButton>
  )
})
